import React, { useState } from 'react';
import {
  Box,
  Stack,
  Chip,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import { EDITABLE_BORDER } from '../constants';

// กล่องหมายเหตุ — ป้าย chip + กรอบเส้นประสีน้ำเงิน คลิกเพื่อแก้ไข (ข้อมูลหลักของแต่ละ Job)
// หมายเหตุ = log สะสม เพิ่มได้อย่างเดียว (บันทึกเก่าล็อกแก้ไขไม่ได้) — บันทึกใหม่ขึ้นบนสุด
// แต่ละรายการ: "D-M-YY ข้อความ — ชื่อผู้ใช้" คั่นด้วยบรรทัดว่างระหว่างรายการ
export function NoteBox({ value, authorName, onSave, uiLang = 'en' }) {
  const U = (th, en) => (uiLang === 'en' ? en : th);
  const [modalOpen, setModalOpen] = useState(false);
  const [draft, setDraft] = useState('');

  const openModal = () => {
    setDraft('');
    setModalOpen(true);
  };

  const handleSave = () => {
    const text = draft.trim();
    if (!text) return;
    const dateStr = dayjs().format('D-M-YY');
    const entry = `${dateStr} ${text} — ${authorName || 'ไม่ระบุ'}`;
    const next = value ? `${entry}\n${value}` : entry;
    onSave(next);
    setModalOpen(false);
  };

  return (
    // ไม่ตั้ง width เอง (เหมือนกล่องป้ายสรุปกำไรคาดการณ์ row 22 ด้านบนที่ก็ไม่ตั้ง width เหมือนกัน) —
    // ปล่อยให้ stretch เต็มคอลัมน์ parent ตาม align-items:stretch ปกติ ขอบขวาเลยชนกับป้ายสรุปกำไร
    // พอดีเสมอไม่ว่าคอลัมน์ parent จะกว้างแคบแค่ไหน (ตั้ง width เป็น px ตายตัวจะทำให้ขอบไม่ตรงกัน
    // ตอนคอลัมน์ parent กว้าง/แคบกว่าตัวเลขที่ตั้งไว้)
    <Box sx={{ mt: 2, flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 0.5, flexShrink: 0 }}
      >
        <Chip
          label={U('หมายเหตุ', 'Notes')}
          size="small"
          sx={{ bgcolor: '#fef3c7', color: '#92400e', fontWeight: 700 }}
        />
        <Button
          size="small"
          variant="outlined"
          onClick={openModal}
          sx={{ fontSize: '0.7rem', py: 0.2, minWidth: 0 }}
        >
          + {U('เพิ่มบันทึก', 'Add note')}
        </Button>
      </Stack>
      <Box
        sx={{
          border: EDITABLE_BORDER,
          borderRadius: 1.5,
          flex: 1,
          minHeight: 90,
          overflowY: 'auto',
          p: 1.5,
          whiteSpace: 'pre-wrap',
          fontSize: '0.8rem',
          color: value ? 'text.primary' : 'text.disabled',
        }}
      >
        {value || U('ยังไม่มีบันทึก', 'No notes')}
      </Box>

      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent sx={{ pt: 2.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
            {U('เพิ่มบันทึกใหม่', 'Add a new note')}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            placeholder={U('พิมพ์ข้อความบันทึก...', 'Enter note...')}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: 1 }}
          >
            {U('บันทึกในชื่อ', 'Saved as')} {authorName || U('ไม่ระบุ', 'Unknown')} · {dayjs().format('D-M-YY')}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setModalOpen(false)}>{U('ยกเลิก', 'Cancel')}</Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!draft.trim()}
          >
            {U('บันทึก', 'Save')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
